// extracted by mini-css-extract-plugin
export var close = "_9B_cjk";
export var fixed = "_9B_ckk";